<template>
  <div class="vertical-nav-tabs">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppVerticalNav',
};
</script>
